














































import { Component, Vue } from "vue-property-decorator";
import { MErrorResourceUnavailable } from "@ulaval/modul-components";
import EnteteULaval from "./components/EnteteULaval.vue";
import PiedPageULaval from "./components/PiedPageULaval.vue";
import MessageErreur from "./components/MessageErreur.vue";

@Component({
  components: {
    MErrorResourceUnavailable,
    EnteteULaval,
    PiedPageULaval,
    MessageErreur,
  },
})
export default class App extends Vue {
  private applicationPrete: boolean = false;

  private enFermetureComplete: boolean =
    process.env.VUE_APP_EN_FERMETURE_COMPLETE === "true";
  private messageAuxUtilisateurs: string =
    process.env.VUE_APP_MESSAGE_AUX_UTILISATEURS || "";

  private hints: [string] = [this.messageAuxUtilisateurs];

  private async mounted(): Promise<void> {
    if (this.$msal.data.isAuthenticated) {
      await this.$msal.query(
        { id: "profile", url: "/me" },
        {
          method: "GET",
          responseType: "json",
        }
      );
    }

    // On s'assure d'avoir récupéré les informations de profil de l'utilisateur avant tout.
    this.applicationPrete = true;
  }

  get estInternetExplorer(): boolean {
    const agent = window.navigator.userAgent;
    const estIE = /MSIE|Trident/.test(agent);

    return estIE;
  }
}
